var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticStyle:{"width":"100%"},attrs:{"border":"0"}},[_c('tbody',[_c('tr',[_c('td',{style:({verticalAlign:_vm.valign})},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }